"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class UserNotAllowedToConnectToSelfError extends client_library_1.ExtendableError {
    constructor() {
        super(`User not allowed to connect to self`);
    }
}
exports.default = UserNotAllowedToConnectToSelfError;
//# sourceMappingURL=UserNotAllowedToConnectToSelfError.js.map